/* *
 * ========================================================================
 * Vortex Solution
 * ========================================================================
 * */

// Includes the custom Modernizr build based on the configurations set in .modernizrrc
require('Modernizr'); // eslint-disable-line import/no-extraneous-dependencies
require('nodelist-foreach-polyfill');
require('element-qsa-scope');
require('./main/dropdown-menu');
require('./main/mobile-menu');
require('./main/user-is-tabbing');
require('./main/forms');

require('./main/header');

require('./main/breadcrumbs');
require('./main/button');
require('./main/entry-content-readmore');

require('./events-listing');
require('./ultimate-member');
require('./accordion-item');

import domReady from '@wordpress/dom-ready';

domReady(() => {
  console.log('dom ready');
});
